import { createContext, useContext } from 'react';
import {
  TActionsMap,
  TDistinctorProperties,
  TGetState,
  TRegisterStateChangeListener,
  TUseProperties,
} from '@apia/dom-store';
import { TCellDistinctions, TGridDistinctions, TState } from './types';
import { operations } from './operations';

export type TStoreContext = {
  actions: TActionsMap<TState, typeof operations>;
  useProps: TUseProperties<
    TState,
    {
      cell: [
        (
          distinctions: TCellDistinctions,
          state: TState,
        ) => TDistinctorProperties,
      ];
      grid: [
        (
          distinctions: TGridDistinctions,
          state: TState,
        ) => TDistinctorProperties,
      ];
    }
  >;
  getState: TGetState<TState>;
  registerStateChangeListener: TRegisterStateChangeListener<TState>;
};

export const StoreContext = createContext<TStoreContext>({} as TStoreContext);

export const useIconsListStoreContext = () => {
  return useContext(StoreContext);
};
